import PendingTransaction from '../PendingTransaction'
import { task, TaskGroup } from 'mobx-task'
import { Env } from 'infra/env'
import link from 'infra/link'
import { makeObservable, computed, action } from 'mobx'

/**
 * View model for a pending transaction.
 */
export class PendingTransactionViewModel {
  /**
   * Task group.
   */
  readonly tasks

  /**
   * Constructor.
   */
  constructor(
    public transaction: PendingTransaction,
    private _selected: (transaction: PendingTransaction) => boolean,
    private _toggleSelection: (transaction: PendingTransaction) => void,
    private _cancelDelegate: () => void,
    private _approveDelegate: () => Promise<void>,
  ) {
    makeObservable(this, {
      selected: computed,
      toggleSelection: action,
    })
    this.tasks = TaskGroup([this.approve])
  }

  /**
   * Whether the transaction is selected.
   */
  get selected() {
    return this._selected(this.transaction)
  }

  /**
   * Toggles the selection.
   */
  toggleSelection = () => {
    this._toggleSelection(this.transaction)
  }

  /**
   * Requests that this transaction be cancelled.
   */
  requestCancellation = () => {
    this._cancelDelegate()
  }

  /**
   * Approve the transaction.
   */
  approve = task.resolved(() => this._approveDelegate())

  /**
   * Views the job in HQ.
   */
  viewJobInHQ = () => {
    if (this.transaction.jobId) {
      window.open(`${Env.HQ_URL}/jobs/${this.transaction.jobId}`, '_blank')
    }
  }

  /**
   * Views the job in a new window.
   */
  viewJob = () => {
    if (this.transaction.jobId) {
      window.open(link.job(this.transaction.jobId), '_blank')
    }
  }
}
